import React, { Suspense } from 'react';
import { StationFilter } from "../../components/Filter/StationFilter";

require("../../utils/Settings");
require("../../utils/Paths");
require("../../utils/Globals");
require("../../utils/Languages");
require("../../utils/Search-Params");
require("../../modules/cookie/cookie");

function App() {
    return (
        <Suspense fallback={<div></div>}>
            <div className="main" style={{ paddingBottom: "30px" }}>
                <StationFilter />
            </div> 
        </Suspense>
    );
}

export default App;